const MessageVoice = ({message}) => {
    return message.file_url && <div className="audio-file-type">
        <audio src={message.file_url} controls></audio>
    </div>
}

export default MessageVoice;